/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Sort_Overridden_AllInputs */



/**
* | output |
* | --- |
* | "All blocked, so they are ordered by how long — sorting applies once one is clear." |
*
* @param {Partner_Billing_Board_Sort_Overridden_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sort_overridden_all = /** @type {((inputs?: Partner_Billing_Board_Sort_Overridden_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sort_Overridden_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle blockiert und daher nach Dauer geordnet — die Sortierung greift, sobald einer frei ist.")
	return /** @type {LocalizedString} */ ("All blocked, so they are ordered by how long — sorting applies once one is clear.")
});